import { createEntityAdapter } from '@reduxjs/toolkit';
import { PermissionResponsePrivate } from '@tests/types';

export const permissionsAdapter = createEntityAdapter<PermissionResponsePrivate<string>>();
